import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/admin-login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/Login')
  },
  {
    path: '*',
    component: () => import('@/views/404')
  }
]

export const normalRouters=[
  {
    path: '/layout',
    name: 'Layout',
    component: () => import('@/views/Layout'),
    children: [
      {
        path: '/open-department',
        name: 'OpenDepartment',
        component: () => import('@/views/OpenDepartment'),
        meta: {title: '开通共享部门'}
      },
      {
        path: '/add-assets',
        name: 'AddAssets',
        component: () => import('@/views/AddAssets'),
        meta: {title: '添加共享设备'}
      },
      {
        path: '/assets-management',
        name: 'AssetsManagement',
        component: () => import('@/views/AssetsManagement'),
        meta: {title: '共享设备管理'}
      },
      {
        path: '/record-query',
        name: 'RecordQuery',
        component: () => import('@/views/RecordQuery'),
        meta: {title: '共享记录查询'}
      },
      {
        path: '/benefit-analysis',
        name: 'BenefitAnalysis',
        component: () => import('@/views/BenefitAnalysis'),
        meta: {title: '效益分析'}
      },
      {
        path: '/bill-management',
        name: 'BillManagement',
        component: () => import('@/views/BillManagement'),
        meta: {title: '账单管理'}
      },
      {
        path: '/parameter-confige',
        name: 'ParameterConfige',
        component: () => import('@/views/ParameterConfige'),
        meta: {title: '业务参数配置'}
      },
      {
        path: '/compute-confige',
        name: 'ComputeConfige',
        component: () => import('@/views/ComputeConfig'),
        meta: {title: '设备使用时长算法配置'}
      },
      {
        path: '/report',
        name: 'Report',
        component: () => import('@/views/Report'),
        meta: {title: '统计报表'}
      }
    ]
  },
  {
    path: '/',
    name: 'DataPlatform',
    component: () => import('@/views/DataPlatform')
  },
];

export const adminRouters = [
  {
    path: '/layout',
    name: 'Layout',
    component: () => import('@/views/Layout'),
    children: [
      {
        path: '/user-management',
        name: 'UserManagement',
        component: () => import('@/views/UserManagement'),
        meta: {title: '用户管理'}
      },
      {
        path: '/open-department',
        name: 'OpenDepartment',
        component: () => import('@/views/OpenDepartment'),
        meta: {title: '开通共享部门'}
      },
      {
        path: '/add-assets',
        name: 'AddAssets',
        component: () => import('@/views/AddAssets'),
        meta: {title: '添加共享设备'}
      },
      {
        path: '/assets-management',
        name: 'AssetsManagement',
        component: () => import('@/views/AssetsManagement'),
        meta: {title: '共享设备管理'}
      },
      {
        path: '/record-query',
        name: 'RecordQuery',
        component: () => import('@/views/RecordQuery'),
        meta: {title: '共享记录查询'}
      },
      {
        path: '/benefit-analysis',
        name: 'BenefitAnalysis',
        component: () => import('@/views/BenefitAnalysis'),
        meta: {title: '效益分析'}
      },
      {
        path: '/bill-management',
        name: 'BillManagement',
        component: () => import('@/views/BillManagement'),
        meta: {title: '账单管理'}
      },
      {
        path: '/parameter-confige',
        name: 'ParameterConfige',
        component: () => import('@/views/ParameterConfige'),
        meta: {title: '业务参数配置'}
      },
      {
        path: '/compute-confige',
        name: 'ComputeConfige',
        component: () => import('@/views/ComputeConfig'),
        meta: {title: '设备使用时长算法配置'}
      },
      {
        path: '/report',
        name: 'Report',
        component: () => import('@/views/Report'),
        meta: {title: '统计报表'}
      }
    ]
  },
  {
    path: '/',
    name: 'DataPlatform',
    component: () => import('@/views/DataPlatform')
  },
];

export const superAdmin = [
  {
    path: '/admin',
    name: 'admin',
    component: () => import('@/views/admin/layout'),
    children: [
      {
        path: 'user-management',
        name: 'UserManagement',
        component: () => import('@/views/admin/UserManagement'),
        meta: {title: '人员管理', icon: 'person'}
      },
    ]
  }
];

const router = new VueRouter({
  scrollBehavior: () => ({y: 0}),
  routes
})

export default router
